// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import { useEffect } from 'react';
import './style.scss';

function Page404() {
  useEffect(() => {
    if (window.location.hash.includes('404')) {
      document.getElementById('app').classList.add('app-404');
    }
  }, []);

  return (
    <>
      <div className="noise" />
      <div className="overlay" />
      <div className="terminal">
        <h1>Error <span className="errorcode">404</span></h1>
        <p className="output">The page you are looking for might have been removed, had its name changed or is temporarily unavailable.</p>
        <p className="output">Please try to <a href="/" target="_blank">return to the homepage</a>.</p>
        <p className="output">Good luck.</p>
      </div>

    </>
  );
}

export default Page404;
